import { flow, types, getEnv } from "mobx-state-tree";

import { endpoints } from "../api/ApiEndpoints";
import { ReportTemplate } from "../organization/ReportTemplate";
import { ReportTemplateResponse } from "../../api-models/response/organization/ReportTemplateResponse";
import { ApplicationError, errorHandler } from "../error-handler/ErrorHandlerService";

const ProjectReportTemplateModel = types.model({
  reportTemplates: types.array(types.frozen<ReportTemplate>()),
  loadingTemplates: types.optional(types.boolean, false)
});

export const ProjectReportTemplateServiceModel = ProjectReportTemplateModel
  .named("ProjectReportTemplateServiceModel")
  .actions((self) => {
    const getReportTemplates = flow(function* () {
      const endpoint = endpoints.get("get_report_templates_all");
      self.loadingTemplates = true;
      try {
        const response = yield getEnv(self).api.post(endpoint, {});
        self.reportTemplates = response.data.results.map(
          (response: ReportTemplateResponse) => new ReportTemplate(response)
        );
      } catch (error) {
        const applicationError = error as ApplicationError;
        errorHandler.handleErrorInSnackbar(applicationError);
      }
      finally {
        self.loadingTemplates = false;
      }
    });

    return {
      async afterCreate() {
        await getReportTemplates();
      }
    }
  });
